<!-- 展示方式Column -->
<template>
    <div>
        <!-- //展示方式 1-数据，10-折线图 -->
      <span v-if="row['showType'].split('')[0] === '1'">{{  $t('public.data') }}</span>
      <span v-if="row['showType'].split('')[0] === '1' && row['showType'].split('')[1] === '1'"> + </span>
      <span v-if="row['showType'].split('')[1] === '1'">{{  $t('integration.line_chart') }}</span>
    </div>
</template>

<script>
export default {
    props: ['row'],
    data() {
        return {

        }
    }
}
</script>
